import moment from 'moment'
import { Link } from 'react-router-dom'
import profilePic from '../../assets/images/male.svg'
export const JuryMemberCardAdmin = ({ name, isActive, createdDate, juryId }) => {
    return (
        <>

            <tr>
                <td width={"100px"}>
                    <span className={isActive == 1 ? "badge badge-pill badge-light-success w-75p py-5" : "badge badge-pill badge-light-danger w-75p py-5"}>
                        {isActive == 1 ? "Active" : "Inactive"}
                    </span>
                </td>
                <td width={"200px"}>
                    <div className="d-flex justify-content-start align-items-center">
                        <div className="starshot-ring mr-1">
                            <div className="avatar">
                                <div className="text-icon font-lato">{name[0]}</div>
                            </div>
                        </div>

                        <div className="profile-user-info">
                            <strong>{name}</strong>
                            <br />
                            <small>Jury name</small>
                        </div>
                    </div>
                </td>
                <td>
                    <strong>NA</strong>
                    <br />
                    <small>Category</small>
                </td>
                <td>
                    <strong>NA</strong>
                    <br />
                    <small>Department</small>
                </td>
                <td>
                    <strong>0</strong>
                    <br />
                    <small>Ideas approved</small>
                </td>
                <td>
                    <strong>0</strong>
                    <br />
                    <small>Ideas rejected</small>
                </td>
                <td className="text-right">
                    <strong>{moment(createdDate).format("MMM Do YY")}</strong>
                    <br />
                    <small>Date</small>
                </td>
                <td className="text-right">
                    <strong>{moment(createdDate).format("LT")}</strong>
                    <br />
                    <small>Time</small>
                </td>
                <td>
                    <Link
                        to={`/jury-list/about/${juryId}`}
                        className="btn btn-primary btn-sm text-white rounded-10 font-11 waves-effect waves-float waves-light"
                    >
                        Details
                    </Link>
                </td>
            </tr>

        </>
    )
}